import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { SocialLoginModule, SocialAuthServiceConfig, GoogleLoginProvider, FacebookLoginProvider } from "@abacritt/angularx-social-login";
import { SocialUser } from '@abacritt/angularx-social-login';

//components
import { HomepageComponent } from './homepage.component';
import { RegisterComponent } from './organizer/register/register.component';
import { LoginComponent } from './organizer/login/login.component';
import { ForgotPswdComponent } from './forgot-pswd/forgot-pswd.component';
import { OrganizerComponent } from './organizer/organizer.component';

//services
import { UserService } from '../shared-services/user.service';
import { GoogleService} from './organizer/register/google.service';

// Configs 
const fbLoginOptions = {
  scope: 'email',
  return_scopes: true
}; 
 
const googleLoginOptions = {
  scope: 'profile email'
};

@NgModule({
  imports: [
    CommonModule,
    SocialLoginModule,
    FormsModule,
    RouterModule,
    SharedModule
  ],
  declarations: [
    RegisterComponent,
    LoginComponent,
    ForgotPswdComponent,
    HomepageComponent,
    OrganizerComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    UserService,
    GoogleService,
  ],
  exports: [
    HomepageComponent,
    OrganizerComponent,
    RegisterComponent,
    LoginComponent,
    ForgotPswdComponent
  ]
})
export class HomepageModule { }
